<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8 4.2L18.4 7.3L15.8 12.8M5.5 17.8L9.1 19.5M5.5 17.8V22.5L9.1 19.5M5.5 17.8L13 1.8C13.2 1.5 13.6 1.3 13.9 1.5L16.3 2.6C16.6 2.8 16.8 3.2 16.6 3.5L9.1 19.5"
      class="stroke-current"
    />
  </svg>
</template>
